import {PersonMe} from "@/domains/-session/models/PersonMe.ts";
import {AbstractWorkspacePerson, GetRoleAny} from "@/domains/-workspace/models/AbstractWorkspacePerson.ts";
import {Workspace} from "@/domains/-workspace/models/Workspace.ts";

export class WorkspacePersonMe extends AbstractWorkspacePerson {
  readonly person: PersonMe;

  constructor(workspace: Workspace, person: PersonMe, roles: GetRoleAny[]) {
    super(workspace, roles);
    this.person = person;
  }
}